document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(min-width: 901px)').matches) {
    document.querySelectorAll('.faq-item').forEach(function (item) { item.open = true; });
  }
  // ── ATLAS MAKE AJAX CART DRAWER CONTROLLER ──
  window.AtlasCart = {
    drawer: document.querySelector('[data-cart-drawer]'),
    body: document.getElementById('cartDrawerBody'),
    countPill: document.getElementById('cartDrawerCount'),
    subtotalEl: document.getElementById('cartDrawerSubtotal'),
    footerEl: document.getElementById('cartDrawerFooter'),
    panel: document.querySelector('.cart-drawer__panel'),

    formatMoney: function(cents) {
      if (typeof cents !== 'number') cents = 0;
      return '$' + (cents / 100).toFixed(2);
    },

    updateBadges: function(count) {
      var badges = document.querySelectorAll('.cart-badge');
      var cartLinks = document.querySelectorAll('.cart-link');
      if (count > 0) {
        badges.forEach(function(b) {
          b.textContent = count;
          b.style.display = 'inline-flex';
        });
        if (badges.length === 0) {
          cartLinks.forEach(function(link) {
            var span = document.createElement('span');
            span.className = 'cart-badge';
            span.textContent = count;
            link.appendChild(span);
          });
        }
      } else {
        badges.forEach(function(b) {
          b.style.display = 'none';
        });
      }
    },

    render: function(cart) {
      if (!this.body) return;
      var count = cart.item_count || 0;
      if (this.countPill) this.countPill.textContent = '(' + count + ')';
      if (this.subtotalEl) this.subtotalEl.textContent = this.formatMoney(cart.total_price);
      if (this.footerEl) {
        this.footerEl.style.display = count > 0 ? 'block' : 'none';
      }
      this.updateBadges(count);

      if (count === 0 || !cart.items || cart.items.length === 0) {
        this.body.innerHTML = 
          '<div class="cart-drawer__empty">' +
            '<div class="empty-icon-wrap">' +
              '<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>' +
                '<line x1="3" y1="6" x2="21" y2="6"></line>' +
                '<path d="M16 10a4 4 0 0 1-8 0"></path>' +
              '</svg>' +
            '</div>' +
            '<h3>Your cart is empty</h3>' +
            '<p>Explore all 114 woodworking plans and start your next build this weekend.</p>' +
            '<a href="/pages/all-projects" class="button button-secondary" data-cart-close>Browse All 114 Plans →</a>' +
          '</div>';
        return;
      }

      var html = '<div class="cart-drawer__items-list">';
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var imgUrl = item.image || (item.featured_image ? item.featured_image.url : '');
        html += 
          '<article class="cart-drawer__item" data-key="' + item.key + '">' +
            '<div class="cart-item__thumb">' +
              (imgUrl ? '<img src="' + imgUrl + '" alt="' + (item.title || 'Plan') + '" width="70" height="56">' : '<div style="width:70px;height:56px;background:#eee;"></div>') +
            '</div>' +
            '<div class="cart-item__details">' +
              '<div class="cart-item__title-row">' +
                '<h4 class="cart-item__title">' + (item.product_title || item.title) + '</h4>' +
                '<button type="button" class="cart-item__remove" aria-label="Remove item" data-item-remove="' + item.key + '">&times;</button>' +
              '</div>' +
              '<span class="cart-item__badge">Instant Download Bundle</span>' +
              '<div class="cart-item__actions">' +
                '<div class="cart-qty-selector">' +
                  '<button type="button" class="qty-btn" aria-label="Decrease quantity" data-qty-action="decrease" data-key="' + item.key + '" data-current-qty="' + item.quantity + '">−</button>' +
                  '<span class="qty-num">' + item.quantity + '</span>' +
                  '<button type="button" class="qty-btn" aria-label="Increase quantity" data-qty-action="increase" data-key="' + item.key + '" data-current-qty="' + item.quantity + '">+</button>' +
                '</div>' +
                '<span class="cart-item__price">' + this.formatMoney(item.final_line_price || item.line_price) + '</span>' +
              '</div>' +
            '</div>' +
          '</article>';
      }
      html += '</div>';
      this.body.innerHTML = html;
    },

    fetchCart: function() {
      var self = this;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          self.render(cart);
          return cart;
        })
        .catch(function(err) {
          console.error('Failed to fetch cart:', err);
        });
    },

    open: function() {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      this.fetchCart();
    },

    close: function() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    },

    changeQty: function(key, newQty) {
      var self = this;
      if (this.panel) this.panel.classList.add('cart-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: parseInt(newQty, 10)
        })
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        self.render(cart);
      })
      .catch(function(err) {
        console.error('Failed to change quantity', err);
      })
      .finally(function() {
        if (self.panel) self.panel.classList.remove('cart-loading');
      });
    },

    init: function() {
      var self = this;
      if (!this.drawer) return;

      // Event delegation for cart actions
      document.addEventListener('click', function(e) {
        // Open trigger
        var opener = e.target.closest('[data-cart-open]');
        if (opener) {
          e.preventDefault();
          self.open();
          return;
        }

        // Close trigger
        var closer = e.target.closest('[data-cart-close]');
        if (closer) {
          e.preventDefault();
          self.close();
          return;
        }

        // Quantity increase / decrease
        var qtyBtn = e.target.closest('[data-qty-action]');
        if (qtyBtn) {
          e.preventDefault();
          var action = qtyBtn.getAttribute('data-qty-action');
          var key = qtyBtn.getAttribute('data-key');
          var currentQty = parseInt(qtyBtn.getAttribute('data-current-qty'), 10) || 1;
          var nextQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
          self.changeQty(key, nextQty);
          return;
        }

        // Item remove
        var removeBtn = e.target.closest('[data-item-remove]');
        if (removeBtn) {
          e.preventDefault();
          var remKey = removeBtn.getAttribute('data-item-remove');
          self.changeQty(remKey, 0);
          return;
        }
      });

      // Escape closes drawer
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && self.drawer.classList.contains('is-open')) {
          self.close();
        }
      });

      // Auto-open drawer if ?cart=open or #cart in URL
      if (window.location.search.indexOf('cart=open') !== -1 || window.location.hash === '#cart') {
        self.open();
      }

      // Product Page AJAX Add to Cart & Quantity Selector
      var productForm = document.getElementById('mainProductForm');
      var qtyInput = document.getElementById('ProductQuantity');
      var qtyMinus = document.querySelector('.prod-qty-minus');
      var qtyPlus = document.querySelector('.prod-qty-plus');

      if (qtyMinus && qtyPlus && qtyInput) {
        qtyMinus.addEventListener('click', function() {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) qtyInput.value = val - 1;
        });
        qtyPlus.addEventListener('click', function() {
          var val = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = val + 1;
        });
      }

      if (productForm) {
        var stickyBar = document.getElementById('mobileStickyBar');
        var stickyBtn = document.querySelector('.sticky-mobile-btn');

        if (stickyBtn) {
          stickyBtn.addEventListener('click', function(e) {
            e.preventDefault();
            productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          });
        }

        if (stickyBar) {
          var ticking = false;
          var updateStickyVisibility = function() {
            var formRect = productForm.getBoundingClientRect();
            // Show sticky bar when the primary add to cart form has scrolled up out of view
            if (formRect.bottom < 80) {
              stickyBar.classList.add('is-visible');
            } else {
              stickyBar.classList.remove('is-visible');
            }
            ticking = false;
          };
          var onScrollOrResize = function() {
            if (!ticking) {
              window.requestAnimationFrame(updateStickyVisibility);
              ticking = true;
            }
          };
          window.addEventListener('scroll', onScrollOrResize, { passive: true });
          window.addEventListener('resize', onScrollOrResize, { passive: true });
          updateStickyVisibility();
        }

        productForm.addEventListener('submit', function(e) {
          e.preventDefault();
          var submitBtn = productForm.querySelector('.button-add-to-cart');
          var originalContent = submitBtn ? submitBtn.innerHTML : '';
          var originalStickyContent = stickyBtn ? stickyBtn.innerHTML : '';

          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.innerHTML = '<span>Adding to Cart...</span>';
          }
          if (stickyBtn) {
            stickyBtn.disabled = true;
            stickyBtn.innerHTML = 'Adding...';
          }

          var formData = new FormData(productForm);
          formData.delete('return_to');

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json' }
          })
          .then(function(res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function() {
            return self.fetchCart();
          })
          .then(function() {
            self.open();
          })
          .catch(function(err) {
            console.error('AJAX add to cart failed, falling back to form submit:', err);
            productForm.submit();
          })
          .finally(function() {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.innerHTML = originalContent;
            }
            if (stickyBtn) {
              stickyBtn.disabled = false;
              stickyBtn.innerHTML = originalStickyContent;
            }
          });
        });
      }
    }
  };

  window.AtlasCart.init();
  // Plan Sheets Interactive Deck & Lightbox Modal
  var planDeck = document.querySelector('.plan-deck-wrap');
  if (planDeck) {
    var tabs = planDeck.querySelectorAll('[data-sheet-tab]');
    var cards = planDeck.querySelectorAll('.plan-sheet-card');
    var modal = document.getElementById('planModal');
    var modalImg = document.getElementById('planModalImg');
    var modalCaption = document.getElementById('planModalCaption');
    var currentSheetIndex = 0;

    function activateSheet(index) {
      if (index < 0 || index >= cards.length) return;
      currentSheetIndex = index;
      tabs.forEach(function (t, i) {
        var isActive = i === index;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      cards.forEach(function (c, i) {
        c.classList.toggle('is-active', i === index);
      });
    }

    tabs.forEach(function (tab) {
      var idx = parseInt(tab.getAttribute('data-sheet-tab'), 10);
      tab.addEventListener('click', function () { activateSheet(idx); });
      tab.addEventListener('mouseenter', function () { activateSheet(idx); });
    });

    cards.forEach(function (card, i) {
      card.addEventListener('mouseenter', function () { activateSheet(i); });
      card.addEventListener('click', function () { openSheetModal(i); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openSheetModal(i);
        }
      });
    });

    function openSheetModal(index) {
      if (!modal || !cards[index]) return;
      currentSheetIndex = index;
      activateSheet(index);
      var card = cards[index];
      var fullSrc = card.getAttribute('data-full-src') || (card.querySelector('img') ? card.querySelector('img').src : '');
      var title = card.getAttribute('data-title') || card.getAttribute('title') || 'Plan Sheet Preview';
      if (modalImg) modalImg.src = fullSrc;
      if (modalCaption) modalCaption.textContent = title;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeSheetModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (modal) {
      modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeSheetModal);
      });
      var prevBtn = modal.querySelector('[data-modal-prev]');
      var nextBtn = modal.querySelector('[data-modal-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var prev = (currentSheetIndex - 1 + cards.length) % cards.length;
          openSheetModal(prev);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var next = (currentSheetIndex + 1) % cards.length;
          openSheetModal(next);
        });
      }
      document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeSheetModal();
        if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
        if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
      });
    }
  }

  /* ==========================================
     1. CATALOG EXPLORER CONTROLLER
     ========================================== */
  var catalogGrid = document.getElementById('catalogGrid');
  if (catalogGrid && window.__ATLAS_CATALOG && Array.isArray(window.__ATLAS_CATALOG)) {
    var searchInput = document.getElementById('catalogSearch');
    var clearSearchBtn = document.getElementById('clearSearch');
    var catPills = document.querySelectorAll('.cat-pill');
    var diffSelect = document.getElementById('difficultySelect');
    var countDisplay = document.getElementById('resultsCount');
    var emptyState = document.getElementById('emptyState');
    var resetBtn = document.getElementById('resetFiltersBtn');
    var stickyBar = document.getElementById('catalogStickyBar');

    var currentCat = 'all';
    var currentSearch = '';
    var currentDiff = 'all';

    // Parse URL query params (?cat=chairs, ?q=table, ?diff=Beginner)
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cat')) {
      var paramCat = urlParams.get('cat').toLowerCase().trim();
      catPills.forEach(function (pill) {
        if (pill.getAttribute('data-cat') === paramCat) {
          currentCat = paramCat;
        }
      });
    }
    if (urlParams.has('q')) {
      currentSearch = urlParams.get('q').trim();
      if (searchInput) searchInput.value = currentSearch;
    }
    if (urlParams.has('diff')) {
      var paramDiff = urlParams.get('diff').trim();
      if (diffSelect) {
        diffSelect.value = paramDiff;
        currentDiff = paramDiff;
      }
    }

    catPills.forEach(function (pill) {
      pill.classList.toggle('active', pill.getAttribute('data-cat') === currentCat);
    });

    function getDifficultyBadgeClass(diff) {
      if (!diff) return 'diff-intermediate';
      var d = diff.toLowerCase();
      if (d.indexOf('beg') !== -1) return 'diff-beginner';
      if (d.indexOf('adv') !== -1) return 'diff-advanced';
      return 'diff-intermediate';
    }

    function renderCatalog() {
      var q = currentSearch.toLowerCase().trim();
      var filtered = window.__ATLAS_CATALOG.filter(function (item) {
        if (currentCat !== 'all' && item.category_slug !== currentCat) {
          return false;
        }
        if (currentDiff !== 'all' && item.difficulty !== currentDiff) {
          return false;
        }
        if (q) {
          var matchTitle = item.name && item.name.toLowerCase().indexOf(q) !== -1;
          var matchNum = item.num && item.num.toLowerCase().indexOf(q) !== -1;
          var matchCat = item.category_name && item.category_name.toLowerCase().indexOf(q) !== -1;
          var matchMat = item.materials && item.materials.toLowerCase().indexOf(q) !== -1;
          if (!matchTitle && !matchNum && !matchCat && !matchMat) {
            return false;
          }
        }
        return true;
      }).sort(function (a, b) {
        return parseInt(a.num, 10) - parseInt(b.num, 10);
      });

      if (countDisplay) {
        countDisplay.textContent = 'Showing ' + filtered.length + ' of ' + window.__ATLAS_CATALOG.length + ' projects';
      }

      if (clearSearchBtn) {
        clearSearchBtn.style.display = currentSearch.length > 0 ? 'block' : 'none';
      }

      if (filtered.length === 0) {
        catalogGrid.innerHTML = '';
        if (emptyState) emptyState.style.display = 'block';
        return;
      }

      if (emptyState) emptyState.style.display = 'none';

      var html = '';
      for (var i = 0; i < filtered.length; i++) {
        var p = filtered[i];
        var diffClass = getDifficultyBadgeClass(p.difficulty);
        html += '<article class="project-card">' +
          '<div class="card-header-meta">' +
            '<span class="card-proj-num">#' + (p.num || (i + 1)) + '</span>' +
            '<span class="card-cat-badge">' + (p.category_name || 'Woodcraft') + '</span>' +
          '</div>' +
          '<h3>' + (p.name || 'Woodworking Project') + '</h3>' +
          '<div class="project-specs">' +
            '<span class="spec-pill ' + diffClass + '">' + (p.difficulty || 'All Levels') + '</span>' +
            '<span class="spec-pill">' + (p.materials || 'Standard Lumber') + '</span>' +
          '</div>' +
          '<div class="project-card-footer">' +
            '<span class="card-included-badge">✓ In Master Pack</span>' +
            '<a href="/products/100-woodworking-projects-complete-diy-master-pack" class="card-action-btn">' +
              '<span>View Bundle</span>' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' +
            '</a>' +
          '</div>' +
        '</article>';
      }
      catalogGrid.innerHTML = html;
    }

    catPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var cat = pill.getAttribute('data-cat');
        currentCat = cat;
        catPills.forEach(function (p) {
          var isActive = p === pill;
          p.classList.toggle('active', isActive);
          p.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        if (history.replaceState) {
          var newUrl = new URL(window.location);
          if (cat === 'all') newUrl.searchParams.delete('cat');
          else newUrl.searchParams.set('cat', cat);
          history.replaceState(null, '', newUrl.toString());
        }
        renderCatalog();
      });
    });

    var searchTimer = null;
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        currentSearch = searchInput.value;
        searchTimer = setTimeout(function () {
          if (history.replaceState) {
            var newUrl = new URL(window.location);
            if (currentSearch) newUrl.searchParams.set('q', currentSearch);
            else newUrl.searchParams.delete('q');
            history.replaceState(null, '', newUrl.toString());
          }
          renderCatalog();
        }, 150);
      });
    }

    if (clearSearchBtn) {
      clearSearchBtn.addEventListener('click', function () {
        if (searchInput) searchInput.value = '';
        currentSearch = '';
        renderCatalog();
      });
    }

    if (diffSelect) {
      diffSelect.addEventListener('change', function () {
        currentDiff = diffSelect.value;
        renderCatalog();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        currentCat = 'all';
        currentSearch = '';
        currentDiff = 'all';
        if (searchInput) searchInput.value = '';
        if (diffSelect) diffSelect.value = 'all';
        catPills.forEach(function (p) {
          p.classList.toggle('active', p.getAttribute('data-cat') === 'all');
        });
        if (history.replaceState) {
          var newUrl = new URL(window.location);
          newUrl.searchParams.delete('cat');
          newUrl.searchParams.delete('q');
          newUrl.searchParams.delete('diff');
          history.replaceState(null, '', newUrl.toString());
        }
        renderCatalog();
      });
    }

    if (stickyBar) {
      var controlsEl = document.querySelector('.catalog-controls');
      var catalogTicking = false;
      var updateCatalogSticky = function () {
        if (!controlsEl) return;
        var rect = controlsEl.getBoundingClientRect();
        if (rect.bottom < 0) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
        catalogTicking = false;
      };
      window.addEventListener('scroll', function () {
        if (!catalogTicking) {
          window.requestAnimationFrame(updateCatalogSticky);
          catalogTicking = true;
        }
      }, { passive: true });
      updateCatalogSticky();
    }

    renderCatalog();
  }

  /* ==========================================
     2. PRODUCT PAGE GALLERY & MOBILE CTA
     ========================================== */
  var mainProdImg = document.getElementById('mainProductImg');
  var thumbBtns = document.querySelectorAll('.prod-thumb-btn');
  if (mainProdImg && thumbBtns.length > 0) {
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var newSrc = btn.getAttribute('data-src');
        if (!newSrc) return;
        // image_tag creates srcset; remove stale candidates before changing src.
        mainProdImg.removeAttribute('srcset');
        mainProdImg.removeAttribute('sizes');
        mainProdImg.src = newSrc;
        var imageWidth = btn.getAttribute('data-width');
        var imageHeight = btn.getAttribute('data-height');
        if (imageWidth && imageHeight) {
          mainProdImg.width = Number(imageWidth);
          mainProdImg.height = Number(imageHeight);
        }
        var thumbImg = btn.querySelector('img');
        if (thumbImg && thumbImg.alt) {
          mainProdImg.alt = thumbImg.alt;
        }
        thumbBtns.forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-current', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-current', 'true');
      });
    });
  }
  /* ==========================================
     3. REVIEWS SHOWCASE FILTER TABS
     ========================================== */
  var revPills = document.querySelectorAll('.rev-pill');
  var showcaseCards = document.querySelectorAll('.showcase-card');
  if (revPills.length > 0 && showcaseCards.length > 0) {
    revPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var filter = pill.getAttribute('data-filter');
        revPills.forEach(function (p) {
          var isActive = p === pill;
          p.classList.toggle('active', isActive);
          p.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        showcaseCards.forEach(function (card) {
          if (filter === 'all') {
            card.style.display = '';
          } else {
            var cat = card.getAttribute('data-category');
            card.style.display = (cat === filter) ? '' : 'none';
          }
        });
      });
    });
  }

  /* ==========================================
     4. FAQ DIRECTORY CATEGORY NAVIGATION
     ========================================== */
  var faqNavPills = document.querySelectorAll('.faq-nav-pill');
  var faqGroups = document.querySelectorAll('.faq-group-block');
  if (faqNavPills.length > 0 && faqGroups.length > 0) {
    faqNavPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var cat = pill.getAttribute('data-faq-cat');
        faqNavPills.forEach(function (p) {
          var isActive = p === pill;
          p.classList.toggle('active', isActive);
          p.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        faqGroups.forEach(function (group) {
          if (cat === 'all') {
            group.style.display = '';
          } else {
            var groupCat = group.getAttribute('data-faq-group');
            group.style.display = (groupCat === cat) ? '' : 'none';
          }
        });
      });
    });
  }

  /* ==========================================
     5. SUBPAGES HEADER ANCHOR LINK FALLBACK
     ========================================== */
  if (window.location.pathname !== '/') {
    var inPageLinks = document.querySelectorAll('header a[href^="#"]');
    inPageLinks.forEach(function (link) {
      var hash = link.getAttribute('href');
      if (hash && hash.length > 1) {
        link.setAttribute('href', '/' + hash);
      }
    });
  }
});
